import React from 'react';
import SecureComponent from '../SecureComponent';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { TextField } from '@mui/material';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';

class WeightInput extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value) {//if store's value relative to this component change, update the state value{
            this.checkValue(newProps.value);
        }
        //this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        this.checkValue(value);
    }

    checkValue = (value) => {
        const maskedStringValue = toMoneyTyping(value, {
            precision: 1
        });
        const floatValue = parseFloat(maskedStringValue.replace(new RegExp(',', 'g'), ''));
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min;
        }
        if (this.props.max !== undefined && this.props.max !== 0 && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping(Math.round(finalFloatValue * 1000) / 100, {
            precision: 1
        });

        this.setState({ value: finalMaskedStringValue });
        this.updateStore(finalMaskedStringValue);
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
    }

    validate(value) {
        const p = this.props;
        let error = null;
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const s = this.state;
        const e = this.state && this.state.error;

        if (!s.authorized) return null;
        return (
            <div className={p.className || "form-group"}>
                <TextField
                    InputLabelProps={{ shrink: true }} 
                    variant={p.variant || "standard"}
                    name={p.name}
                    underlineShow={p.underlineShow}
                    label={p.hintText}
                    errorText={(s.value.trim() === ' ' || s.value.trim() === '' || s.value <= 0) ? p.error : ''}
                    value={s.value}
                    inputStyle={p.inputStyle}
                    hintStyle={p.hintStyle}
                    floatingLabelStyle={p.floatingLabelStyle}
                    floatingLabelText={p.floatingLabelText}
                    className={p.className}
                    ref={p.ref}
                    disabled={p.disabled}
                    fullWidth={p.fullWidth || false}
                    onChange={(e) => this.onChange(e)}
                    onBlur={(e) => this.onBlur(e)} />
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel
    };
};

export default connect(mapStateToProps)(WeightInput);
